export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    slots: { default: 'opt' },
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.table_label_expand') || '展开',
    slots: { content: 'expandContent' },
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_batch_no') || '交货批次号',
    field: 'orderBatchNo',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_retailer_po') || '零售商PO',
    field: 'retailerPo',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_importer_po') || '代理商PO',
    field: 'importerPo',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_identify_no') ||
      '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_delivery_date') || '工厂交期',
    field: 'deliveryDate',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_shipment_date') || '客户交期',
    field: 'shipmentDate',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_production_order_goods_qty') || '产品数',
    field: 'totQty',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title: that.$l('INDEX.table_label_production_order_box_qty') || '箱数',
    field: 'totBoxQty',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title: that.$l('INDEX.order_form_batch_label_packingType') || '装箱方式',
    field: 'v_packingType',
    align: 'center',
    width: 90,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_materialSpec') || '包装规格',
    field: 'materialSpec',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_materialSpec') || '包装规格',
    field: 'v_deliveryType',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.batch_label_outBillType') || '出单类型',
    field: 'v_outBillType',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_packing_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.order_form_batch_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_receiver') || '收货人',
    field: 'receiver',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_receiverPhone') || '联系电话',
    field: 'receiverPhone',
    headerAlign: 'center',
    align: 'left',
    minWidth: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_receiverAddress') || '收货地址',
    field: 'receiverAddress',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
